module.exports = __webpack_public_path__ + "static/Proposal-Boards3-97423ad910ae8da917132b1a50cc322b.png";